module.exports = __webpack_public_path__ + "img/konfigurasi_top_up_&_cashback.5ae92f9c.svg";